// assets
import { IconDashboard, IconDeviceAnalytics, IconFileInvoice, IconArticle, IconLifebuoy, IconBrandWhatsapp } from '@tabler/icons-react';

// types
import { NavItemType } from 'types';

const icons = {
  IconDashboard: IconDashboard,
  IconDeviceAnalytics: IconDeviceAnalytics,
  IconFileInvoice: IconFileInvoice,
  IconArticle: IconArticle,
  IconLifebuoy: IconLifebuoy,
  IconBrandWhatsapp: IconBrandWhatsapp
};

// ==============================|| MENU ITEMS - DASHBOARD ||============================== //

const main: NavItemType = {
  id: 'main',
  title: '',
  icon: icons.IconDashboard,
  type: 'group',
  children: [
    {
      id: 'dashboard',
      title: 'dashboard',
      type: 'item',
      url: '/dashboard/default',
      icon: icons.IconDashboard,
      breadcrumbs: false
    },
    {
      id: 'orders',
      title: 'Orders',
      icon: icons.IconFileInvoice,
      type: 'collapse',
      children:[
        {
        id: 'view_orders',
        title: 'View Orders',
        type: 'item',
        url: '/customer/orders',
        breadcrumbs: false,
      },
      {
        id: 'create_orders',
        title: 'Create Orders',
        type: 'item',
        url: '/createOrder',
        breadcrumbs: false,
      }
    ]
    },
    {
      id: 'whatsapp_integration',
      title: 'WhatsApp Integration',
      type: 'item',
      url: '/whatsappintegration',
      icon: icons.IconBrandWhatsapp,
      breadcrumbs: false
    }

  ]
};

export default main;
